import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';

/**
 * Modifiers picker dialog for a selected menu item.
 * Extracted from CashierPOSPage to keep that page focused on the POS shell.
 * Supports single-select and multi-select modifier groups (required flag rendered
 * visually via the red asterisk; enforcement happens in the parent's addToCart).
 */
export default function ModifiersDialog({
  open,
  onOpenChange,
  selectedItem,
  selectedModifiers,
  setSelectedModifiers,
  confirmModifiers,
  currencySymbol = 'SAR',
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[90dvh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{selectedItem?.name}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 max-h-[72dvh] overflow-y-auto">
          {(selectedItem?._filteredModifiers || selectedItem?.modifiers || []).map((group, gi) => (
            <div key={gi} className="space-y-2">
              <Label className="font-semibold">
                {group.name} {group.required && <span className="text-error">*</span>}
              </Label>
              <div className="grid grid-cols-2 gap-2">
                {group.options?.map((opt, oi) => {
                  const isSelected = group.multiple
                    ? selectedModifiers[group.name]?.some((s) => s.name === opt.name)
                    : selectedModifiers[group.name]?.name === opt.name;
                  return (
                    <Button
                      key={oi}
                      variant={isSelected ? 'default' : 'outline'}
                      className={`justify-start h-auto py-2 ${isSelected ? 'bg-orange-500' : ''}`}
                      onClick={() => {
                        if (group.multiple) {
                          const current = selectedModifiers[group.name] || [];
                          const exists = current.findIndex((s) => s.name === opt.name);
                          if (exists >= 0) {
                            current.splice(exists, 1);
                          } else {
                            current.push(opt);
                          }
                          setSelectedModifiers({ ...selectedModifiers, [group.name]: [...current] });
                        } else {
                          setSelectedModifiers({ ...selectedModifiers, [group.name]: opt });
                        }
                      }}
                    >
                      <div className="text-left">
                        <p className="text-sm">{opt.name}</p>
                        {opt.price > 0 && (
                          <p className="text-xs opacity-70">
                            +{currencySymbol} {opt.price}
                          </p>
                        )}
                      </div>
                    </Button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={confirmModifiers}
            className="bg-orange-500 hover:bg-orange-600"
            data-testid="confirm-modifiers-btn"
          >
            Add to Cart
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
